import * as React from "react";

const SvgTheTubeTerminal = ({ active }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 203.833 203.833"
    style={{
      enableBackground: "new 0 0 203.833 203.833",
      width: "50px",
      height: "50px",
      marginBottom: "15px",
      marginTop: "5px",
    }}
    xmlSpace="preserve"
  >
    <path
      style={{ fill: active === 3 ? "black" : "white" }}
      d="M156.229 203.833H47.604a3 3 0 0 1-3-3V14.094C44.604 6.322 50.926 0 58.698 0h86.438c7.771 0 14.094 6.322 14.094 14.094v186.739a3.001 3.001 0 0 1-3.001 3zm-105.625-6h102.625v-57.667H50.604v57.667zm0-63.666h102.625V14.094c0-4.463-3.631-8.094-8.094-8.094H58.698c-4.463 0-8.094 3.631-8.094 8.094v120.073zm42.982-6.948H92.02a3 3 0 1 1 0-6h1.566a3 3 0 1 1 0 6zm-12.857 0h-1.566a3 3 0 1 1 0-6h1.566a3 3 0 1 1 0 6zm-12.856 0h-1.566a3 3 0 1 1 0-6h1.566a3 3 0 1 1 0 6zm69.654-4.198h-23.213a3 3 0 0 1-3-3v-14.956a3 3 0 0 1 3-3h23.213a3 3 0 0 1 3 3v14.956a3 3 0 0 1-3 3zm-20.213-6h17.213v-8.956h-17.213v8.956zm-23.728.621H92.02a3 3 0 1 1 0-6h1.566a3 3 0 1 1 0 6zm-12.857 0h-1.566a3 3 0 1 1 0-6h1.566a3 3 0 1 1 0 6zm-12.856 0h-1.566a3 3 0 1 1 0-6h1.566a3 3 0 1 1 0 6zm25.713-9.577H92.02a3 3 0 1 1 0-6h1.566a3 3 0 1 1 0 6zm-12.857 0h-1.566a3 3 0 1 1 0-6h1.566a3 3 0 1 1 0 6zm-12.856 0h-1.566a3 3 0 1 1 0-6h1.566a3 3 0 1 1 0 6zm69.654-13.644h-71.22a3 3 0 0 1-3-3V23.203a3 3 0 0 1 3-3h71.22a3 3 0 0 1 3 3v68.218a3 3 0 0 1-3 3zm-68.22-6h65.22V26.203h-65.22v62.218z"
    />
  </svg>
);

export default SvgTheTubeTerminal;
